var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    style: {
      fill: "#888"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#888"
    },
    d: "M 0.5,4.5 15.5,4.5 15.5,15.5 0.5,15.5 Z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 2,
    y: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 5,
    y: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 11,6 3,0 0,5 -2,0 0,-3 -1,0 z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 12,
    y: 12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 5,
    y: 12
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 9,
    y: 9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 6,
    y: 9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 2,
    y: 12
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 2,
    y: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.0e97e1038bddb936e86296ea4ab42588.svg";
export { ForwardRef as ReactComponent };